import { Injectable } from '@angular/core';
import { Base } from "./base";

export class MonthlyCutBase extends Base {
    month?: number;
    year?: number;
    constructor(json) {
        super(json);
    }
    get monthName() {
        if (this.month)
            return MonthlyCutBase.translatedMonths[this.month];
        return '';
    }
    static translatedMonths = [
        '', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre',
        'Octubre', 'Noviembre', 'Diciembre'
    ];
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Classes/monthly-cut-base.ts